var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendMessage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8379 9.16502L3.11354 10.2149C3.02474 10.227 2.9414 10.2579 2.87191 10.3046C2.80242 10.3513 2.74923 10.4121 2.71769 10.4809L0.0543633 16.3016C-0.19997 16.8369 0.486115 17.3472 1.1158 17.0896L19.5755 9.56071C19.7031 9.50855 19.8103 9.42846 19.8853 9.3294C19.9603 9.23034 20 9.11622 20 8.99981C20 8.88339 19.9603 8.76927 19.8853 8.67021C19.8103 8.57116 19.7031 8.49107 19.5755 8.43891L1.1158 0.91003C0.486115 0.653212 -0.19997 1.1635 0.0543633 1.69805L2.71871 7.51871C2.75025 7.5875 2.80345 7.64829 2.87294 7.69499C2.94243 7.74169 3.02576 7.77264 3.11457 7.78473L10.8389 8.83459C10.8871 8.84086 10.931 8.86094 10.9626 8.89122C10.9943 8.9215 11.0117 8.96 11.0117 8.99981C11.0117 9.03961 10.9943 9.07811 10.9626 9.10839C10.931 9.13867 10.8871 9.15875 10.8389 9.16502H10.8379Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessage);
export default __webpack_public_path__ + "static/media/send-message.af296845eb87a4f8c76f11f7554f75bd.svg";
export { ForwardRef as ReactComponent };